import React from 'react';

const DarwinFilterOption = ({ label, subLabel, isSelected, onClick, name, id }) => (
  <label
    htmlFor={id}
    className={`darwin-filter-option ${isSelected ? 'darwin-filter-option--selected' : ''}`}
    onMouseDown={(event) => event.preventDefault()}
  >
    <input
      id={id}
      type="radio"
      name={name}
      className="darwin-filter-option__input"
      checked={isSelected}
      onChange={onClick}
    />
    <span className="darwin-filter-option__content">
      <span className="darwin-filter-option__label">{label}</span>
      {subLabel ? (
        <span className="darwin-filter-option__sub-label">{subLabel}</span>
      ) : null}
    </span>
    <span className="darwin-filter-option__radio" aria-hidden="true">
      {isSelected ? <span className="darwin-filter-option__radio-dot" /> : null}
    </span>
  </label>
);

export default DarwinFilterOption;
